// This function is a hack, tried to achieve 4 lines of text in mobile
// devices including Iphone SE and 3 lines of text in desktop when collapsed.
export const generateAdaptiveContent = ({
  description,
  innerWidth,
  expanded,
  component
}) => {
  if (expanded) {
    return `${description.slice(0, -4)}${component}</p>`
  }

  const rawText = description.replace(/<\/?p>/g, '').replace(/<\/?ul>/g, '').replace(/<\/?li>/g, '')
  let length = 155
  if (innerWidth < 345) { // check
    length = 110
  } else if (innerWidth >= 345 && innerWidth < 380) { // check
    length = 135
  } else if (innerWidth >= 380 && innerWidth < 400) { // check
    length = 150
  } else if (innerWidth >= 400 && innerWidth < 420) { // check
    length = 160
  } else if (innerWidth >= 420 && innerWidth < 450) { // check
    length = 170
  } else if (innerWidth >= 450 && innerWidth < 500) { // check
    length = 195
  } else if (innerWidth >= 500 && innerWidth < 550) { // check
    length = 220
  } else if (innerWidth >= 550 && innerWidth < 600) { // check
    length = 255
  } else if (innerWidth >= 600 && innerWidth < 650) { // check
    length = 280
  } else if (innerWidth >= 650 && innerWidth < 730) { // check
    length = 310
  } else if (innerWidth >= 730 && innerWidth < 768) { // check
    length = 370
  } else if (innerWidth >= 768 && innerWidth < 900) {
    length = 390
  } else if (innerWidth >= 900 && innerWidth < 1000) {
    length = 470
  } else if (innerWidth >= 1000 && innerWidth < 1024) {
    length = 480
  } else if (innerWidth >= 1024 && innerWidth < 1100) {
    length = 90
  } else if (innerWidth >= 1100 && innerWidth < 1200) {
    length = 110
  } else if (innerWidth >= 1200 && innerWidth < 1300) {
    length = 130
  } else if (innerWidth >= 1300 && innerWidth < 1400) {
    length = 155
  } else if (innerWidth >= 1400 && innerWidth < 1440) {
    length = 180
  } else if (innerWidth >= 1440) {
    length = 185
  }

  let textPreview = description
  if (length < description.length) {
    textPreview = length < rawText.length ? `${rawText.slice(0, length)}...` : rawText
    return `<p>${textPreview}${component}</p>`
  }
  return description
}
